import { compose, setDisplayName, lifecycle, mapProps } from 'recompose'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchStoreTemplates } from 'store/storeTemplates/actions'
import { selectStoreTemplates, selectFetchStoreTemplatesStatus } from 'store/storeTemplates/selectors'
import { selectStoreId } from 'store/preferences/selectors'
import { STORE_TEMPLATE_ICONS } from 'helpers/icons'

const mapStateToProps = (state) => ({
  storeId: selectStoreId(state),
  storeTemplates: selectStoreTemplates(state),
  fetchStoreTemplatesStatus: selectFetchStoreTemplatesStatus(state),
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({ fetchStoreTemplates }, dispatch)
);

export const withFetchStoreTemplates = () => (
  compose(
    setDisplayName('StoreTemplates'),
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle({
      componentDidMount() {
        const { storeTemplates, fetchStoreTemplates } = this.props
        if(!storeTemplates.length){
          fetchStoreTemplates()
        }
      },
    }),
  )
)

export const withStoreTemplatesState = () => (
  compose(
    setDisplayName('StoreTemplates'),
    connect(mapStateToProps),
    mapProps(
      ({ fetchStoreTemplatesStatus, storeId, ...props }) => ({
        isLoading: fetchStoreTemplatesStatus.isRequest,
        getStoreTemplateIcon: (refTemplate) => (
          STORE_TEMPLATE_ICONS[storeId] ?
            STORE_TEMPLATE_ICONS[storeId][refTemplate]
            :
            ''
        ),
        ...props,
      })
    )
  )
)




// WEBPACK FOOTER //
// ./src/store/storeTemplates/storeTemplateHocs.js